import {
  Alert,
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  Typography,
  useTheme,
  Collapse,
  IconButton,
  Checkbox,
  FormGroup,
  Drawer,
  useMediaQuery,
  Slider,
  ToggleButtonGroup,
  ToggleButton,
  Divider,
} from "@mui/material";

import useStyles from "./styles";
import { useEffect, useMemo, useState } from "react";
import api from "../../../services/api";
import apiPublic from "../../../services/apiPublic";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Check,
  CloseOutlined,
  MapOutlined,
  Animation,
  FilterList,
  ShortText,
  Menu,
  MenuOpen,
  SaveOutlined,
  RestoreOutlined,
  PaletteOutlined,
} from "@mui/icons-material";
import AlertModal from "../../alertModal";
import { useMapa } from "../../../contexts/mapaContext";
import {
  setLocalMapConfig,
  removeLocalMapConfig,
  hasLocalMapConfig,
} from "../../../utils/easyMapsLocalConfig";
import CustomTreeView from "../../sideBar/customTreeView";
import { useOutletContext } from "react-router-dom";
import FiltroEscala from "../configModal/filtroEscala";
import { v4 as uuidv4 } from "uuid";
import PingEscala from "../configModal/pingEscala";
import { GifInfoPopover } from "./popover";
import animacaoAlertaGif from "../../../assets/easyMaps/gifs/animacao_alertas_maps.gif";
import animacaoLinhaGif from "../../../assets/easyMaps/gifs/animacao_linhas_maps.gif";
import animacaoCorredorGif from "../../../assets/easyMaps/gifs/animacao_runner_maps.gif";
import imageClassico from "../../../assets/easyMaps/classico.png";
import imagePreenchido from "../../../assets/easyMaps/preenchido.png";
import usePermissao from "../../../hooks/usePermissao";
const temaOptions = [
  {
    value: "classico",
    label: "Clássico",
    img: imageClassico,
    novo: false,
    description:
      "Borda dos elementos recebe a cor de status. Somente hosts em desastre aparecem totalmente preenchidos.",
  },
  {
    value: "preenchido",
    label: "Preenchido",
    img: imagePreenchido,
    novo: true,
    description:
      "Elementos totalmente preenchidos com a cor de status e borda flutuante. Hosts em desastre exibem o ícone de fogo.",
  },
];

export default function ConfiguracaoMapModal({
  open,
  setOpen = () => {},
  isPing = false,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [openAlertModal, setOpenAlertModal] = useState(null);
  const [checkChanges, setCheckChanges] = useState(false);
  const isDownMd = useMediaQuery(theme.breakpoints.down("md"));
  // página de alertas
  const [filterInterface, setFilterInterface] = useState(false);
  const [filterItems, setFilterItems] = useState(false);
  const [filterSeverity, setFilterSeverity] = useState(false);
  const [severityLevels, setSeverityLevels] = useState({
    5: true,
    4: false,
    3: false,
    2: false,
  });
  const [pageIndex, setPageIndex] = useState("1");
  const [escalaTrafego, setEscalaTrafego] = useState([]);
  const [escalaPotencia, setEscalaPotencia] = useState([]);
  const [filtroPotencia, setFiltroPotencia] = useState([]);
  const [filtroTrafego, setFiltroTrafego] = useState([]);
  const [filtroPing, setFiltroPing] = useState([]);
  const [animacaoLinha, setAnimacaoLinha] = useState(true);
  const [animacaoAlerta, setAnimacaoAlerta] = useState(true);
  const [animacaoCorredor, setAnimacaoCorredor] = useState(true);

  //exlusivo ftth
  const [escalaFtth, setEscalaFtth] = useState([]);
  const [filtroFtth, setFiltroFtth] = useState([]);
  const [esconderOnu, setEsconderOnu] = useState(true);
  const [showOnusWithoutCto, setShowOnusWithoutCto] = useState(false);
  const [defaultSelectedItems, setDefaultSelectedItems] = useState(["1"]);

  const { config } = useOutletContext();
  const [hasLocal, setHasLocal] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [larguraEnlace, setlarguraEnlace] = useState(7);
  const [viewType, setViewType] = useState("compact");
  const [sizeEdgeLabel, setSizeEdgeLabel] = useState(1);
  const [sizeNode, setSizeNode] = useState(1);
  const [temaElemento, setTemaElemento] = useState("classico");

  const marksEnlace = [
    { value: 1, label: "1" },
    { value: 15, label: "15" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];

  function ensureEscalaId(escala) {
    return (escala || []).map((item) =>
      item.id ? item : { ...item, id: uuidv4() },
    );
  }

  const {
    configurationMap,
    setConfigurationMap,
    setSnackbar,
    updateDataElementSocket,
    mapId,
    tipo,
    isPublic,
  } = useMapa();
  const { canEdit } = usePermissao("easyMaps");

  useEffect(() => {
    if (open) {
      setFilterInterface(
        configurationMap?.configuracoes?.alerts?.filterInterface?.enable ||
          false,
      );
      setFilterItems(
        configurationMap?.configuracoes?.alerts?.filterItens?.enable || false,
      );
      setFilterSeverity(
        configurationMap?.configuracoes?.alerts?.filterSeverity?.enable ||
          false,
      );
      setSeverityLevels(
        configurationMap?.configuracoes?.alerts?.filterSeverity?.severity || {
          5: true,
          4: false,
          3: false,
          2: false,
        },
      );
      setCheckChanges(false);
      setHasLocal(hasLocalMapConfig(mapId, isPublic));

      setEscalaPotencia(
        ensureEscalaId(config?.configuracoes?.[tipo]?.camadaPotencia?.escala),
      );
      setEscalaTrafego(
        ensureEscalaId(config?.configuracoes?.[tipo]?.camadaTrafego?.escala),
      );
      setEscalaFtth(
        ensureEscalaId(config?.configuracoes?.[tipo]?.camadaFTTH?.escala),
      );
      setFiltroPotencia(
        configurationMap?.configuracoes?.camadaPotencia?.filtros || [],
      );
      setFiltroTrafego(
        configurationMap?.configuracoes?.camadaTrafego?.filtros || [],
      );
      setFiltroFtth(configurationMap?.configuracoes?.camadaFTTH?.filtros || []);
      setFiltroPing(configurationMap?.configuracoes?.camadaPing?.filtros || []);

      setAnimacaoLinha(
        configurationMap?.configuracoes?.animacao?.linha != null
          ? configurationMap?.configuracoes?.animacao?.linha
          : true,
      );
      setAnimacaoCorredor(
        configurationMap?.configuracoes?.animacao?.corredorLinha != null
          ? configurationMap?.configuracoes?.animacao?.corredorLinha
          : true,
      );
      setAnimacaoAlerta(
        configurationMap?.configuracoes?.animacao?.alertas != null
          ? configurationMap?.configuracoes?.animacao?.alertas
          : true,
      );
      setEsconderOnu(
        configurationMap?.configuracoes?.esconderOnu != null
          ? configurationMap?.configuracoes?.esconderOnu
          : true,
      );
      setShowOnusWithoutCto(
        configurationMap?.configuracoes?.showOnusWithoutCto != null
          ? configurationMap?.configuracoes?.showOnusWithoutCto
          : false,
      );
      setPageIndex({ title: "Animações", id: "1" });
      setlarguraEnlace(
        configurationMap?.configuracoes?.larguraEnlace != null
          ? configurationMap?.configuracoes?.larguraEnlace
          : 7,
      );
      setViewType(
        configurationMap?.configuracoes?.viewType != null
          ? configurationMap?.configuracoes?.viewType
          : "compact",
      );
      setSizeEdgeLabel(
        configurationMap?.configuracoes?.edgeLabelSize != null
          ? configurationMap?.configuracoes?.edgeLabelSize
          : 1,
      );
      setSizeNode(
        configurationMap?.configuracoes?.nodeSize != null
          ? configurationMap?.configuracoes?.nodeSize
          : 1,
      );
      setTemaElemento(
        configurationMap?.configuracoes?.temaElemento != null
          ? configurationMap?.configuracoes?.temaElemento
          : "classico",
      );
    }
  }, [open, configurationMap, config]);

  const handleClose = () => {
    setFilterInterface(false);
    setFilterItems(false);
    setFilterSeverity(false);
    setCheckChanges(false);
    setOpen(false);
    setSeverityLevels({ 5: false, 4: false, 3: false, 2: false });
    setDefaultSelectedItems(["1"]);
  };

  function buildConfiguracoes() {
    if (tipo === "ftth") {
      return {
        ...configurationMap?.configuracoes,
        tipo,
        animacao: {
          linha: animacaoLinha,
          alertas: animacaoAlerta,
        },
        esconderOnu: esconderOnu,
        showOnusWithoutCto: showOnusWithoutCto,
        camadaFTTH: {
          filtros: filtroFtth,
        },
      };
    }
    return {
      ...configurationMap?.configuracoes,
      tipo,
      alerts: {
        filterInterface: { enable: filterInterface },
        filterItens: { enable: filterItems },
        filterSeverity: {
          enable: filterSeverity,
          severity: severityLevels,
        },
      },
      animacao: {
        linha: animacaoLinha,
        corredorLinha: animacaoCorredor,
        alertas: animacaoAlerta,
      },
      camadaPotencia: {
        filtros: filtroPotencia,
      },
      camadaTrafego: {
        filtros: filtroTrafego,
      },
      camadaPing: {
        filtros: filtroPing,
      },
      larguraEnlace: larguraEnlace,
      viewType: viewType,
      edgeLabelSize: sizeEdgeLabel,
      nodeSize: sizeNode,
      temaElemento: temaElemento,
    };
  }

  async function handleSaveLocal() {
    const built = buildConfiguracoes();
    const ok = setLocalMapConfig(mapId, built, isPublic);
    if (ok) {
      setConfigurationMap((prev) => ({
        ...prev,
        configuracoes: { ...prev?.configuracoes, ...built },
      }));
      setHasLocal(true);
      setSnackbar({
        children: "Configurações locais salvas para este mapa.",
        severity: "success",
      });
      handleClose();
    } else {
      setSnackbar({
        children:
          "Erro: Não foi possível salvar localmente. Armazenamento indisponível.",
        severity: "error",
      });
    }
  }

  async function handleRestaurarPadrao() {
    removeLocalMapConfig(mapId, isPublic);
    setHasLocal(false);
    try {
      // só leitura: no link público relê pela rota pública
      const response = isPublic
        ? await apiPublic.post("/easyMaps/public/map/findMapById", { mapId })
        : await api.post("/easyMaps/map/findMapById", { mapId });
      if (response.data && response.data.status !== "Error") {
        const { ConfigMapEasyMaps } = response.data;
        setConfigurationMap(ConfigMapEasyMaps || { configuracoes: null });
      }
      setSnackbar({
        children: "Configuração padrão restaurada.",
        severity: "success",
      });
      handleClose();
    } catch (error) {
      setSnackbar({
        children: "Erro ao restaurar a configuração padrão.",
        severity: "error",
      });
    }
  }

  async function handleApiUpdateConfigMap() {
    // link público nunca grava no banco: lá só existe o salvar local
    if (isPublic || !canEdit) return;

    const data = {
      id: configurationMap?.id,
      data: {
        ...configurationMap,
        mapId,
        configuracoes: buildConfiguracoes(),
      },
    };

    try {
      const response = await api.put("/easyMaps/map/config/update", data);

      if (response.data.status === "Error") {
        setSnackbar({
          children:
            "Error: Não foi possível salvar as mudanças as configurações",
          severity: "error",
        });
      } else {
        if (response.data) {
          setConfigurationMap(response.data);
          removeLocalMapConfig(mapId, isPublic);
          setHasLocal(false);
          handleClose();
          updateDataElementSocket?.();
          setSnackbar({
            children: "Configurações do mapa salvas com sucesso!",
            severity: "success",
          });
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  function handleSeverityChange(level) {
    const newLevels = { ...severityLevels, [level]: !severityLevels[level] };
    setSeverityLevels(newLevels);
    setCheckChanges(true);
  }

  const rightBarPages = useMemo(
    () => [
      {
        itemId: "1",
        label: "Animações",
        icon: <Animation />,
      },
      {
        itemId: "2",
        label: "Filtros",
        icon: <FilterList />,
      },
      ...(tipo != "ftth" && !isPing
        ? [
            {
              itemId: "3",
              label: "Gerais",
              icon: <MapOutlined />,
            },
          ]
        : []),
      ...(tipo === "geo" && !isPing
        ? [
            {
              itemId: "4",
              label: "Tema",
              icon: <PaletteOutlined />,
            },
          ]
        : []),
    ],
    [tipo, isPing],
  );

  const handleDrawerToggle = () => {
    setOpenDrawer((prevState) => !prevState);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 1500 }}
      >
        <Card sx={isDownMd ? styles.containerMobile : styles.container}>
          <Stack
            sx={isDownMd ? styles.containerTabMobile : styles.containerTab}
          >
            {isDownMd ? (
              <>
                <IconButton sx={{ ml: 1 }} onClick={handleDrawerToggle}>
                  <MenuIcon />
                </IconButton>
                <Typography sx={[styles.pageTitleMobile]}>
                  Ajustes do mapa
                </Typography>
                <Drawer
                  key={"Drawer-mobile"}
                  variant="temporary"
                  open={openDrawer}
                  onClose={() => setOpenDrawer(false)}
                  sx={styles.drawerMobile}
                >
                  <CustomTreeView
                    key="mobile-treeview"
                    fullWidth={true}
                    open={true}
                    defaultSelectedItems={defaultSelectedItems}
                    setOpen={() => {}}
                    //closeOnClickItem
                    titlePage={"Configurações"}
                    onItemSelect={(item) => {
                      setOpenDrawer(false);
                      setPageIndex({ title: item.label, id: item.itemId });
                    }}
                    onItemsIdSelected={(items) => {
                      setDefaultSelectedItems(items);
                    }}
                    items={rightBarPages}
                  />
                </Drawer>
              </>
            ) : (
              <>
                <Typography sx={[styles.pageTitle, { mb: -2 }]}>
                  Ajustes do mapa
                </Typography>

                <CustomTreeView
                  key="desktop-treeview"
                  fullWidth={true}
                  open={true}
                  defaultSelectedItems={defaultSelectedItems}
                  setOpen={() => {}}
                  //closeOnClickItem
                  titlePage={"Configurações"}
                  onItemSelect={(item) => {
                    setOpenDrawer(false);
                    setPageIndex({ title: item.label, id: item.itemId });
                  }}
                  items={rightBarPages}
                />
              </>
            )}
          </Stack>
          <Stack sx={styles.containerData}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ ...styles.pageTitle, ...styles.titlePage }}>
                {pageIndex.title}
              </Typography>
              <IconButton
                onClick={() => {
                  if (!checkChanges) {
                    handleClose();
                    return;
                  }
                  setOpenAlertModal({
                    open: true,
                    callback: handleClose,
                    severity: "warning",
                    text: "As alterações feitas não foram salvas. Se prosseguir com a operação as mudanças serão perdidas.",
                  });
                }}
                // sx={styles.buttomEnd}
                size="small"
              >
                <CloseOutlined />
              </IconButton>
            </Box>
            <Stack
              gap={1.5}
              sx={{ height: "100%", overflow: "auto", pr: "5px" }}
            >
              {pageIndex.id == "1" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Switch
                      checked={animacaoAlerta}
                      onChange={() => {
                        setAnimacaoAlerta(!animacaoAlerta);
                        setCheckChanges(true);
                      }}
                      sx={styles.switch}
                    />
                    <Stack direction="column">
                      <Stack
                        display="flex"
                        direction="row"
                        alignItems="center"
                        gap={1}
                      >
                        <Typography sx={styles.text}>
                          {" "}
                          Animação de Alertas
                        </Typography>
                        <GifInfoPopover
                          title="Animação de Alertas"
                          img={animacaoAlertaGif}
                        />
                      </Stack>

                      <Typography sx={{ ...styles.textFine }}>
                        Ativa animação visual para alertas nos itens do mapa
                      </Typography>
                    </Stack>
                  </Box>
                  {!isPing && (
                    <>
                      <Box sx={styles.boxOP}>
                        <Switch
                          checked={animacaoLinha}
                          onChange={() => {
                            setAnimacaoLinha(!animacaoLinha);
                            setCheckChanges(true);
                          }}
                          sx={styles.switch}
                        />

                        <Stack direction="column">
                          <Stack
                            display="flex"
                            direction="row"
                            alignItems="center"
                            gap={1}
                          >
                            <Typography sx={styles.text}>
                              {" "}
                              Animação de Linhas
                            </Typography>
                            <GifInfoPopover
                              title="Animação de Linhas"
                              img={animacaoLinhaGif}
                            />
                          </Stack>

                          <Typography sx={{ ...styles.textFine }}>
                            Ativa animação visual para os enlaces dos itens do
                            mapa
                          </Typography>
                        </Stack>
                      </Box>
                      {tipo == "top" && (
                        <Box sx={styles.boxOP}>
                          <Switch
                            checked={animacaoCorredor}
                            onChange={() => {
                              setAnimacaoCorredor(!animacaoCorredor);
                              setCheckChanges(true);
                            }}
                            sx={styles.switch}
                          />

                          <Stack direction="column">
                            <Stack
                              display="flex"
                              direction="row"
                              alignItems="center"
                              gap={1}
                            >
                              <Typography sx={styles.text}>
                                {" "}
                                Animação de fluxo de dados
                              </Typography>
                              <GifInfoPopover
                                title="Animação de Fluxo de Dados"
                                img={animacaoCorredorGif}
                              />
                            </Stack>

                            <Typography sx={{ ...styles.textFine }}>
                              Ativa animação da representação visual do fluxo de
                              dados nos enlaces.
                            </Typography>
                          </Stack>
                        </Box>
                      )}
                    </>
                  )}
                </>
              )}
              {pageIndex.id == "2" && (
                <>
                  {tipo != "ftth" && (
                    <>
                      <Box sx={styles.boxOP}>
                        <Switch
                          checked={filterInterface}
                          onChange={() => {
                            setFilterInterface(!filterInterface);
                            setCheckChanges(true);
                          }}
                          sx={styles.switch}
                        />
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            {" "}
                            Filtro de Alertas por Interface do host
                          </Typography>

                          <Typography sx={{ ...styles.textFine }}>
                            Mostra apenas alertas relacionados às interfaces
                            vinculadas aos hosts exibidos no mapa.
                          </Typography>
                        </Stack>
                        <Stack sx={{ p: 1 }}>
                          <Collapse
                            in={filterInterface}
                            timeout={300}
                            unmountOnExit
                          >
                            <FormControl>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                                value={filterItems ? "true" : "false"}
                                onChange={(e) => {
                                  setFilterItems(e.target.value === "true");
                                  setCheckChanges(true);
                                }}
                              >
                                <FormControlLabel
                                  value={"false"}
                                  control={<Radio />}
                                  label={
                                    <Typography sx={styles.textSize}>
                                      Exibir alertas de todos os itens das
                                      interfaces selecionadas e itens
                                      explicitamente adicionados
                                    </Typography>
                                  }
                                />
                                <FormControlLabel
                                  value={"true"}
                                  control={<Radio />}
                                  label={
                                    <Typography sx={styles.textSize}>
                                      Exibir alertas apenas dos itens
                                      explicitamente adicionados
                                    </Typography>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </Collapse>
                        </Stack>
                      </Box>

                      <Box sx={styles.boxOP}>
                        <Switch
                          checked={filterSeverity}
                          onChange={() => {
                            setFilterSeverity(!filterSeverity);
                            setCheckChanges(true);
                          }}
                          sx={styles.switch}
                        />
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            {" "}
                            Filtro de Alertas por Severidade
                          </Typography>

                          <Typography sx={{ ...styles.textFine }}>
                            Escolha os níveis de severidade que deseja
                            visualizar nos alertas
                          </Typography>
                        </Stack>
                        <Stack sx={{ p: 1 }}>
                          <Collapse
                            in={filterSeverity}
                            timeout={300}
                            unmountOnExit
                          >
                            {/* <TextField
                          sx={styles.textField}
                          type="number"
                          //value={linkLight}
                          //onChange={(e) => {}}
                          size="small"
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Typography sx={styles.textAdorment}>
                                    Nivel de Severidade
                                  </Typography>
                                </InputAdornment>
                              ),
                            },
                          }}
                        /> */}
                            <FormGroup
                              sx={{
                                display: "flex",
                                flexDirection: "row-reverse",
                                justifyContent: "flex-end",
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled
                                    defaultChecked
                                    //checked={severityLevels[5]}
                                    //onChange={() => handleSeverityChange(5)}
                                  />
                                }
                                label="Desatre"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={severityLevels[4]}
                                    onChange={() => handleSeverityChange(4)}
                                  />
                                }
                                label="Alto Impacto"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={severityLevels[3]}
                                    onChange={() => handleSeverityChange(3)}
                                  />
                                }
                                label="Moderado"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={severityLevels[2]}
                                    onChange={() => handleSeverityChange(2)}
                                  />
                                }
                                label="Alerta"
                              />
                            </FormGroup>
                          </Collapse>
                        </Stack>
                        <Collapse
                          in={filterSeverity}
                          timeout={300}
                          unmountOnExit
                        >
                          <Alert severity="info" sx={{ mt: 1 }}>
                            <Typography sx={styles.textFine}>
                              O filtro de severidade sobrepõe outros filtros. Se
                              estiver ativo, apenas os alertas com a severidade
                              selecionada serão exibidos.
                            </Typography>
                          </Alert>
                        </Collapse>
                      </Box>
                    </>
                  )}

                  {tipo != "ftth" && !isPing ? (
                    <>
                      <FiltroEscala
                        unit=""
                        type="Potência"
                        escala={escalaPotencia}
                        filtroData={filtroPotencia}
                        setCheckChanges={setCheckChanges}
                        setFiltroData={setFiltroPotencia}
                        theme={theme}
                        styles={styles}
                      />
                      <FiltroEscala
                        inverted={true}
                        unit=""
                        type="Tráfego"
                        escala={escalaTrafego}
                        filtroData={filtroTrafego}
                        setCheckChanges={setCheckChanges}
                        setFiltroData={setFiltroTrafego}
                        theme={theme}
                        styles={styles}
                      />
                    </>
                  ) : null}

                  {isPing && (
                    <PingEscala
                      theme={theme}
                      styles={styles}
                      setFiltroPing={setFiltroPing}
                      filtroPing={filtroPing}
                      setCheckChanges={setCheckChanges}
                    />
                  )}

                  {tipo == "ftth" && (
                    <>
                      <Box sx={styles.boxOP}>
                        <Switch
                          checked={esconderOnu}
                          onChange={() => {
                            setEsconderOnu(!esconderOnu);
                            setCheckChanges(true);
                          }}
                          sx={styles.switch}
                        />
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            {" "}
                            Ocultar ONUs com CTO
                          </Typography>

                          <Typography sx={{ ...styles.textFine }}>
                            Quando ativo, as ONUs serão ocultadas no mapa. Para
                            exibir as ONUs será necessário selecionar uma CTO,
                            clicando nela no mapa.
                          </Typography>
                        </Stack>
                      </Box>
                      <Box sx={styles.boxOP}>
                        <Switch
                          checked={!showOnusWithoutCto}
                          onChange={() => {
                            setShowOnusWithoutCto(!showOnusWithoutCto);
                            setCheckChanges(true);
                          }}
                          sx={styles.switch}
                        />
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            {" "}
                            Filtrar ONUs sem CTO
                          </Typography>

                          <Typography sx={{ ...styles.textFine }}>
                            Quando ativo, apenas as ONUs que tem uma CTO serão
                            exibidas no mapa
                          </Typography>
                        </Stack>
                      </Box>
                      <FiltroEscala
                        unit="dBm"
                        type="Potência"
                        escala={escalaFtth}
                        filtroData={filtroFtth}
                        setCheckChanges={setCheckChanges}
                        setFiltroData={setFiltroFtth}
                        theme={theme}
                        styles={styles}
                      />
                    </>
                  )}
                </>
              )}
              {pageIndex.id == "3" && tipo != "ftth" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Espessura do Enlace
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Selecione o nível de espessura das linhas que
                        representam os enlaces no mapa. Opções mais altas tornam
                        as linhas mais grossas, facilitando a visualização em
                        mapas com muitos enlaces. No entanto, espessuras maiores
                        podem deixar o mapa visualmente mais carregado.
                      </Typography>
                    </Stack>

                    <Stack
                      justifyContent={"center"}
                      mt={2}
                      sx={{ width: "98%", p: "0px 19px" }}
                    >
                      <Slider
                        aria-label="Espessura do enlace"
                        value={larguraEnlace}
                        onChange={(e) => {
                          setCheckChanges(true);
                          setlarguraEnlace(e.target.value);
                        }}
                        min={1}
                        max={50}
                        step={1}
                        marks={marksEnlace}
                        valueLabelDisplay="auto"
                        size="small"
                      />
                    </Stack>
                    <Alert severity="info" sx={{ mt: 1 }}>
                      <Typography sx={styles.textFine}>
                        Valores menores (1 a 15) são ideais para notebooks e
                        celulares. Para visualização em TVs e telões, utilize
                        valores maiores, garantindo boa leitura à distância.
                      </Typography>
                    </Alert>
                  </Box>
                  {tipo === "top" && (
                    <>
                      <Box sx={styles.boxOP}>
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            Tipo de visualização
                          </Typography>

                          <Typography sx={{ ...styles.textFine }}>
                            Selecione o tipo de visualização dos elementos no
                            mapa.
                          </Typography>
                        </Stack>

                        <Stack justifyContent={"center"} mt={2}>
                          <ToggleButtonGroup
                            value={viewType}
                            exclusive
                            onChange={(e, nextView) => {
                              if (nextView !== null) {
                                setCheckChanges(true);
                                setViewType(nextView);
                              }
                            }}
                            aria-label="Tipo de visualização"
                            size="small"
                            sx={{
                              backgroundColor:
                                theme.palette.background.paperLinkedMaps,
                              padding: 1,
                              borderRadius: 2,
                              border: "none",
                              width: "fit-content",
                            }}
                          >
                            {" "}
                            <ToggleButton sx={styles.toggleBtn} value="compact">
                              <ShortText />
                              Compacto
                            </ToggleButton>{" "}
                            <Divider
                              flexItem
                              orientation="vertical"
                              sx={{ my: 0.5, mx: 1 }}
                            />
                            <ToggleButton sx={styles.toggleBtn} value="simple">
                              <Menu />
                              Simples
                            </ToggleButton>
                            <Divider
                              flexItem
                              orientation="vertical"
                              sx={{ my: 0.5, mx: 1 }}
                            />
                            <ToggleButton
                              sx={styles.toggleBtn}
                              value="detailed"
                            >
                              <MenuOpen />
                              Detalhado
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </Stack>
                      </Box>
                      <Box sx={styles.boxOP}>
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            Tamanho do rótulo da linha
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              ...styles.textFine,
                              mb: 1,
                              color: "text.secondary",
                            }}
                          >
                            Personalize tamanho dos rótulos das linhas,
                            selecionando uma opção.
                          </Typography>
                        </Stack>

                        <Stack
                          justifyContent={"center"}
                          mt={1}
                          sx={{ width: "98%", p: "0px 19px" }}
                        >
                          <Slider
                            value={Number(sizeEdgeLabel)}
                            min={1}
                            max={50}
                            step={1}
                            marks={marksEnlace}
                            onChange={(e, val) => {
                              setSizeEdgeLabel(val);
                              setCheckChanges(true);
                            }}
                            valueLabelDisplay="auto"
                            size="small"
                          />
                        </Stack>
                      </Box>
                      <Box sx={styles.boxOP}>
                        <Stack direction="column">
                          <Typography sx={styles.text}>
                            Tamanho do elemento
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              ...styles.textFine,
                              mb: 1,
                              color: "text.secondary",
                            }}
                          >
                            Personalize o tamanho dos elementos (nodes) do mapa.
                            Este valor é aplicado aos elementos que não possuem
                            um tamanho individual definido.
                          </Typography>
                        </Stack>

                        <Stack
                          justifyContent={"center"}
                          mt={1}
                          sx={{ width: "98%", p: "0px 19px" }}
                        >
                          <Slider
                            value={Number(sizeNode)}
                            min={1}
                            max={50}
                            step={1}
                            marks={marksEnlace}
                            onChange={(e, val) => {
                              setSizeNode(val);
                              setCheckChanges(true);
                            }}
                            valueLabelDisplay="auto"
                            size="small"
                          />
                        </Stack>
                      </Box>
                    </>
                  )}
                </>
              )}
              {pageIndex.id == "4" && tipo === "geo" && (
                <Box sx={{ ...styles.boxOP, gap: 1 }}>
                  <Stack direction="column">
                    <Typography sx={styles.text}>Tema dos Elementos</Typography>
                    <Typography sx={styles.textFine}>
                      Escolha como os elementos (hosts) devem ser exibidos no
                      mapa. A alteração é apenas visual e afeta todos os ícones
                      do mapa atual.
                    </Typography>
                  </Stack>

                  <Stack direction={{ xs: "column", sm: "row" }} gap={2}>
                    {temaOptions.map((op) => {
                      const selected = temaElemento === op.value;
                      return (
                        <Box
                          key={op.value}
                          onClick={() => {
                            setTemaElemento(op.value);
                            setCheckChanges(true);
                          }}
                          sx={styles.temaCard(selected)}
                        >
                          {op.novo && (
                            <Typography component="span" sx={styles.temaBadge}>
                              NOVO
                            </Typography>
                          )}
                          <Box sx={styles.temaCheck(selected)}>
                            {selected && <Check sx={{ fontSize: 14 }} />}
                          </Box>
                          <Box
                            component="img"
                            src={op.img}
                            alt={op.label}
                            sx={styles.temaImg}
                          />
                          <Typography sx={styles.text}>{op.label}</Typography>
                          <Typography
                            sx={{ ...styles.textFine, width: "100%" }}
                          >
                            {op.description}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Stack>
                </Box>
              )}
            </Stack>
            <Stack
              direction={"row"}
              gap={1}
              justifyContent={"space-between"}
              sx={{ mt: 2, mb: 1 }}
            >
              <Box sx={{ height: "35px" }}>
                {hasLocal && (
                  <Button
                    onClick={handleRestaurarPadrao}
                    sx={styles.buttomEnd}
                    startIcon={<RestoreOutlined />}
                    variant="text"
                    color="warning"
                    size="small"
                  >
                    Restaurar padrão
                  </Button>
                )}
              </Box>
              <Box sx={{ height: "35px", gap: 1, display: "flex" }}>
                {/* link público: só salvar local, nada vai para o banco */}
                {!isPublic && canEdit && (
                  <Button
                    onClick={() => {
                      setOpenAlertModal({
                        open: true,
                        callback: handleApiUpdateConfigMap,
                        severity: "warning",
                        buttonText: "Salvar como padrão",
                        text: "Isto altera a configuração padrão deste mapa, carregada sempre que o mapa for aberto para todos os usuários. Deseja continuar?",
                      });
                    }}
                    sx={styles.buttomEnd}
                    variant="outlined"
                    color="primary"
                    startIcon={<Check />}
                    disabled={!checkChanges}
                    size="small"
                  >
                    Salvar como padrão
                  </Button>
                )}
                <Button
                  onClick={handleSaveLocal}
                  sx={styles.buttomEnd}
                  variant="contained"
                  color="primary"
                  startIcon={<SaveOutlined />}
                  disabled={!checkChanges}
                  size="small"
                >
                  Salvar localmente
                </Button>
              </Box>
            </Stack>
          </Stack>
        </Card>
      </Modal>

      <AlertModal
        openModal={openAlertModal?.open ?? false}
        setOpenModal={(data) => setOpenAlertModal({ open: data })}
        buttonText={openAlertModal?.buttonText}
        buttonCancelText={openAlertModal?.buttonCancelText}
        confirmar={false}
        handleButton={() => {
          setOpenAlertModal({ open: false });
          if (openAlertModal.callback) {
            openAlertModal.callback(...(openAlertModal?.params || []));
            return;
          }
        }}
        severity={openAlertModal?.severity}
        singleButton={false}
        textContent={openAlertModal?.text}
      />
    </>
  );
}
